import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=ea9ce7dc&scoped=true"
import script from "./CampaignCard.vue?vue&type=script&lang=js"
export * from "./CampaignCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignCard.vue?vue&type=style&index=0&id=ea9ce7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9ce7dc",
  null
  
)

export default component.exports